import React, {useEffect, useMemo, useState} from 'react';
import {connect} from 'react-redux';
import {useParams} from 'react-router-dom';
import {SecondaryButton, SkeletonLoader} from '../../components';
import * as Actions from '../../store/actions';

const timelineLimit = 4;

function ActivityLog({
  verifications: {timeline, loading},
  getTimeline,
  session,
}) {
  const [next, setNext] = useState(timelineLimit);
  const {slug} = useParams();

  useEffect(() => {
    if (slug) {
      getTimeline(slug);
    }
  }, [getTimeline, slug]);

  const timeLineData = useMemo(
    () => !loading && timeline?.data,
    [timeline, loading],
  );

  const handleLoadMore = () => {
    setNext(next + timelineLimit);
  };

  const LogData = useMemo(() => {
    if (loading) return Array(timelineLimit).fill('');
    const filtered = session
      ? timeLineData.filter(t => t?.session_id === session) || []
      : timeLineData || [];
    return filtered?.slice(0, next) || [];
  }, [loading, next, session, timeLineData]);

  const SlimLoader = ({styles}) => (
    <SkeletonLoader
      style={{
        height: 10,
        width: 120,
        marginBottom: 0,
        ...styles,
      }}
    />
  );

  return (
    <div className="p-4 mt-4 rounded bg-white80 lg:bg-white grow lg:grow-0 text-start">
      <p className="text-xs font-medium uppercase text-grey">Activity log</p>
      <div className="mt-4">
        <div className="grid">
          {LogData?.map((time, index) => (
            <div
              key={index}
              className="activity-parent grid gap-[6px] grid-rows-[2rem] h-full py-[4px]"
            >
              <span
                className="relative grid items-center text-xs font-medium text-body activity-time
              after:content-[''] after:absolute after:border-r after:border-dashed after:border-grey60 after:h-[40px] after:right-[-3px]"
              >
                {loading ? (
                  <SlimLoader styles={{width: 50}} />
                ) : (
                  <>
                    {time?.datetime?.split(' ')?.pop()?.replace('+00:00', '')}
                  </>
                )}
              </span>
              <span
                className="text-sm lowercase  veri text-body activity-description leading-[12px]  relative grid items-center pl-2
              before:content-[''] before:absolute before:bg-brandBlue before:rounded-full before:w-[5px] before:h-[5px] before:top-1/2 before:left-[-3px] before:-mt-[1px] "
              >
                {loading ? (
                  <SlimLoader styles={{width: 50 * (index + 1)}} />
                ) : (
                  <>{time?.event_value ?? '-'}</>
                )}
              </span>
            </div>
          ))}
        </div>

        {next < timeLineData?.length && (
          <SecondaryButton
            className="flex items-start gap-2 mt-4"
            fontSize="text-xs"
            xPadding="px-2"
            yPadding="pt-[9px] pb-[7px]"
            btnHeight="h-7"
            buttonText="Load more"
            onClick={handleLoadMore}
          />
        )}
      </div>
    </div>
  );
}

export default connect(state => state, Actions)(ActivityLog);
